import { makeStyles } from '@material-ui/core';

const styles = makeStyles((_theme) => ({
  input: {
    marginBottom: 2,
    marginTop: 0,
  },
}));

export default styles;
